import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { Currencyprops } from "../../../../../domain/models/invoice";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import HelperMask from "../../../../helpers/helper-mask";

export const Fields = (
  developerCompaniesList: DeveloperCompanyModel[],
  currencies: Currencyprops[],
  currentNote: any,
): GroupProp[] => [
  {
    groupName: "Prestador",
    groupLabel: "Prestador:",
    items: [
      {
        name: "company",
        type: "select",
        validations: "inputRequired",
        label: "Selecione a empresa que emitirá o invoice*:",
        filter: true,
        initialValue: currentNote?.company,
        options: developerCompaniesList?.map((el) => ({
          value: el?.id,
          label: `${HelperMask.applyCnpjMask(
            el.company?.subscriptionNumber || "",
          )} — ${el.company?.socialReason}`,
          rawCnpj: (el.company?.subscriptionNumber || "").replace(/\D/g, ""),
        })),
        filterBy: "label,rawCnpj",
        col: { xs: 12, md: 12, lg: 12 },
      },
    ],
  },
  {
    groupName: "CLIENTE",
    groupLabel: "Dados do Cliente (Bill to):",
    items: [
      {
        name: "companyName",
        type: "text",
        label: "Razão Social/Nome*:",
        initialValue: currentNote?.companyName,
        validations: "inputRequired",
        col: { xs: 12, md: 12, lg: 12 },
      },
      {
        name: "addressName",
        type: "text",
        label: "Endereço*:",
        initialValue: currentNote?.addressName,
        validations: "inputRequired",
        col: { xs: 12, md: 12, lg: 12 },
      },
      {
        name: "city",
        type: "text",
        label: "Cidade:",
        initialValue: currentNote?.city,
        col: { xs: 4, md: 4, lg: 4 },
      },
      {
        name: "state",
        type: "text",
        label: "Estado/Província:",
        initialValue: currentNote?.state,
        col: { xs: 4, md: 4, lg: 4 },
      },
      {
        name: "nation",
        type: "text",
        label: "País*:",
        initialValue: currentNote?.nation,
        validations: "inputRequired",
        col: { xs: 4, md: 4, lg: 4 },
      },
      {
        name: "postalCode",
        type: "text",
        label: "CEP / Zip Code:",
        initialValue: currentNote?.postalCode,
        col: { xs: 4, md: 4, lg: 4 },
      },
    ],
  },
  {
    groupName: "SERVICE",
    groupLabel: "Dados do Serviço:",
    items: [
      {
        name: "serviceDescription",
        type: "textarea",
        label: "Discriminação do(s) serviço(s)*:",
        initialValue: currentNote?.serviceDescription,
        validations: "inputRequired",
        rows: 6,
        col: { xs: 12, md: 12, lg: 12 },
      },
      {
        name: "currency",
        type: "select",
        label: "Moeda*:",
        filter: true,
        initialValue: currentNote?.currency,
        options: currencies?.map((el) => ({
          value: el?.id,
          label: `${el?.name} - ${el?.code} - ${el?.symbol}`,
        })),
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "serviceValue",
        type: "currency",
        label: "Valor do Serviço*:",
        placeholder: "0,00",
        initialValue: currentNote?.serviceValue,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
    ],
  },
  {
    groupName: "BANK",
    groupLabel: "Dados Bancários (Pay to):",
    items: [
      {
        name: "bankName",
        type: "text",
        label: "Banco*:",
        initialValue: currentNote?.bankName,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "bankAgency",
        type: "text",
        label: "Agência*:",
        initialValue: currentNote?.bankAgency,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "bankAccount",
        type: "text",
        label: "Conta*:",
        initialValue: currentNote?.bankAccount,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "bankDigit",
        type: "text",
        label: "Dígito*:",
        initialValue: currentNote?.bankDigit,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
    ],
  },
  {
    groupName: "DUE",
    groupLabel: "Vencimento:",
    items: [
      {
        name: "date",
        type: "date",
        label: "Data de Vencimento (Due Date):",
        initialValue: currentNote?.date,
        col: { xs: 4, md: 4, lg: 4 },
      },
    ],
  },
];
